"use strict";
/**
 * @file 比例尺控件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 比例尺控件，默认位于地图左下角
 * @visibleName ScaleControl 比例尺控件
 */
var ScaleControl = /** @class */ (function (_super) {
    tslib_1.__extends(ScaleControl, _super);
    function ScaleControl(props) {
        return _super.call(this, props) || this;
    }
    ScaleControl.prototype.getControl = function () {
        return new BMapGL.ScaleControl(this.getOptions());
    };
    ScaleControl.prototype.render = function () {
        return null;
    };
    return ScaleControl;
}(Control_1.default));
exports.default = ScaleControl;
